import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const BasketLineRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};

  &:last-of-type {
    border-bottom: none;
  }
`

export const BasketLineIdentity = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 14rem;
  flex: 0 0 14rem;
  padding-top: 0.5rem;
`

export const BasketLineName = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const BasketLineSku = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
  font-variant-numeric: tabular-nums;
`

export const BasketLineFields = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  flex: 1;
`

export const BasketLineValue = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 700;
  color: ${tokens.text.secondary};
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  padding-top: 0.75rem;
  min-width: 5.5rem;
  text-align: right;
`

export const NatureToggle = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem;
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.chip};
  background: ${tokens.surface.inset};
  width: max-content;
`

export const NatureToggleOption = styled.button<{ $active?: boolean }>`
  border: 1px solid ${({ $active }) => ($active ? tokens.accent.base : 'transparent')};
  border-radius: ${tokens.radius.chip};
  padding: 0.25rem 0.5rem;
  font-size: ${tokens.font.label};
  font-weight: 600;
  cursor: pointer;
  background: ${({ $active }) => ($active ? tokens.accent.soft : 'transparent')};
  color: ${({ $active }) => ($active ? tokens.accent.base : tokens.text.secondary)};
  transition: all ${tokens.motion.duration} ${tokens.motion.ease};

  &:hover {
    color: ${({ $active }) => ($active ? tokens.accent.base : tokens.text.primary)};
  }
`

export const BasketSummaryBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 1rem;
  margin-top: 1rem;
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
`

export const BasketSummaryText = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.secondary};
  font-variant-numeric: tabular-nums;
`

export const KindFilterBar = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
`

export const KindFilterPill = styled.button<{ $active?: boolean }>`
  border: 1px solid ${({ $active }) => ($active ? tokens.accent.base : tokens.border.hairline)};
  border-radius: 999px;
  padding: 0.25rem 0.75rem;
  font-size: ${tokens.font.label};
  font-weight: 600;
  cursor: pointer;
  background: ${({ $active }) => ($active ? tokens.accent.soft : 'transparent')};
  color: ${({ $active }) => ($active ? tokens.accent.base : tokens.text.secondary)};
  transition: all ${tokens.motion.duration} ${tokens.motion.ease};

  &:hover {
    color: ${({ $active }) => ($active ? tokens.accent.base : tokens.text.primary)};
  }
`

export const LedgerValueText = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 700;
  color: ${tokens.text.secondary};
  font-variant-numeric: tabular-nums;
`

export const LedgerMetaText = styled.span`
  font-size: ${tokens.font.body};
  color: ${tokens.text.secondary};
`

export const CustodyItemText = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
  font-variant-numeric: tabular-nums;
`

export const ServeRequestBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid ${tokens.accent.base};
  border-radius: ${tokens.radius.control};
  background: ${tokens.accent.soft};
`

export const ServeRequestBannerText = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const ReturnLineRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};
  cursor: pointer;

  &:last-of-type {
    border-bottom: none;
  }
`

export const ReturnLineInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
  min-width: 0;
`

export const ReturnLineMeta = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const RecentReturnRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};

  &:last-of-type {
    border-bottom: none;
  }
`
